'use client';

import Link from 'next/link';
import { trackCTAClick } from '@/lib/analytics';
import useScrollReveal from '@/hooks/useScrollReveal';

export default function CTASection() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollReveal<HTMLElement>();

  return (
    <section ref={sectionRef} className="relative py-20 md:py-24 bg-gradient-to-br from-brand-orange via-brand-coral to-brand-orange text-white overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-1/4 w-80 h-80 bg-brand-yellow rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-10 right-1/4 w-96 h-96 bg-brand-teal rounded-full blur-3xl animate-pulse-slow"></div>
      </div>
      
      <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <h2 className="font-headline text-4xl md:text-5xl mb-6">
          Not Sure Where to Start?
        </h2>
        <p className="font-body text-xl md:text-2xl mb-8 text-white/95 max-w-2xl mx-auto">
          Let's talk about what's actually broken and figure out what you need to fix it. No sales pitch. No pressure. Just an honest conversation about whether we're a good fit.
        </p>
        <Link
          href="/contact"
          onClick={() => trackCTAClick('Start the Conversation', 'CTA Section - Services')}
          className="group inline-flex items-center gap-3 px-10 py-5 bg-white text-brand-orange font-body font-bold text-lg rounded-xl hover:bg-brand-yellow hover:text-brand-plum hover:shadow-hover transition-all duration-300 shadow-button transform hover:scale-105 active:scale-95 active:shadow-md"
        >
          Start the Conversation
          <span className="text-2xl group-hover:translate-x-1 transition-transform">→</span>
        </Link>
      </div>
    </section>
  );
}